<template>
  <div class="process">
    <myDialog :logTitle="'调解进度'" :showDialog.sync="open">
      <el-button type="primary" class="close" icon="el-icon-circle-close" size="medium" @click="close"/>
      <div class="main-content">
        <el-timeline :reverse="true">
          <el-timeline-item v-for="(item, index) in processList" :key="index" :timestamp="item.createTime">
            <p class="title">{{ item.stepTitle }}</p>
            <p class="desc">{{ item.stepDesc }}</p>
          </el-timeline-item>
        </el-timeline>
      </div>
    </myDialog>
  </div>
</template>

<script>
import myDialog from '@/components/custom/myDialog.vue'

export default {
  name: 'MediationProcess',
  components: {myDialog},
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    processList: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {}
  },
  created() {

  },
  methods: {
    close() {
      this.$emit('close', false);
    }
  }
}
</script>

<style lang="scss">
.process {
  width: 100%;

  .close {
    position: absolute;
    top: 10px;
    right: 10px;
    background-color: #0F1F46;
  }

  .close:hover {
    background-color: #0F1F46;
  }

  .logContent {
    width: 80%;
  }

  .main-content {
    color: rgb(177, 227, 255);
    padding-left: 10px;
    padding-right: 10px;

    .title{
      font-size: 18px;
      color: #FFFFFF;
    }

    .desc{
      font-size: 15px;
      color: #FFFFFF;
    }

    .el-timeline-item__timestamp{
      color: #FFFFFF !important;
    }
  }
}

</style>>
